/**
 * Google Ads conversion tracking (gtag.js) — separate from GA4
 * (visitorTracker.js) and Clarity. Prod-only by design: REACT_APP_GOOGLE_ADS_ID
 * is set in .env but deliberately left unset in .env.staging, so staging
 * test bookings never get counted as real ad conversions. Same env-scoping
 * pattern as REACT_APP_GA_MEASUREMENT_ID.
 */

const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const RAKHI_BOOKING_CONVERSION = "AW-18380036707/rysdCICh4N4cEOO0pLxE";
// "Traveller Registration" (Sign-up category, count: One) — created 2026-10-20
// for the Bangalore→Delhi traveller campaign (/travel/blr-del).
const TRAVELLER_REGISTRATION_CONVERSION = "AW-18380036707/njAqCM6Ll6MdEOO0pLxE";

let adsInitialized = false;

export function initGoogleAds() {
  if (!ADS_ID || adsInitialized) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);

  adsInitialized = true;
}

/** Fire the Rakhi Express booking-complete conversion. No-op off prod (ADS_ID unset). */
export function trackRakhiBookingConversion() {
  if (!adsInitialized || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: RAKHI_BOOKING_CONVERSION,
    value: 1.0,
    currency: "INR",
  });
}

/**
 * Fire the traveller-registration conversion. Call ONLY after saveUserData has
 * created the TravelerRequest — i.e. after OTP verification and the server's
 * one-live-request check — so a page view or a rejected duplicate never counts.
 * Sends no user data (no phone, PNR or name): Google attributes it to the ad
 * click through its own click-ID cookie. No-op off prod (ADS_ID unset).
 */
export function trackTravellerRegistrationConversion() {
  if (!adsInitialized || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: TRAVELLER_REGISTRATION_CONVERSION,
  });
}
